import React, { useState } from "react";
import classNames from "classnames";
import styles from "./TriggerSet.module.scss";
import { Trigger } from "./Trigger";
import { CollapsibleTrigger } from "./CollapsibleTrigger";

export interface SubChoice {
  label        : string;
  iconName?    : string;
  iconPosition?: "before" | "after";
  panelKey     : string;
}

export interface TriggerSetProps {
  choices                         : string[];
  subChoices?                     : SubChoice[];
  onChoiceChange?                 : (index: number) => void;
  orientation?                    : "vertical" | "horizontal";
  exclusive?                      : boolean;
  actived?                        : boolean[];
  /** Pastille rouge sur le bouton de même rang : « quelque chose attend ici ». */
  badges?                         : boolean[];
  classNameNormal?                : string;
  classNamePushed?                : string;
  variant?                        : "default" | "tailwind1" | "tailwind2" | "custom";
  width?                          : string;
  height?                         : string;
  padding?                        : string;
  margin?                         : string;
  buttonForegroundColor?          : string;
  buttonBackgroundColor?          : string;
  buttonBackgroundHoverColor?     : string;
  buttonForegroundHoverColor?     : string;
  buttonBackgroundSelectedColor?  : string;  // ✅ Nouveau
  buttonForegroundSelectedColor?  : string;  // ✅ Nouveau
  buttonBackgroundDisabledColor?  : string;
  buttonForegroundDisabledColor?  : string;
  collapsibleBackgroundColor?     : string;
  collapsibleForegroundColor?     : string;
  titleBackgroundColor?           : string;
  titleForegroundColor?           : string;
  titleBackgroundHoverColor?      : string;
  titleForegroundHoverColor?      : string;
}

export const TriggerSet = ({
  choices,
  subChoices,
  onChoiceChange,
  orientation                    = "vertical",
  exclusive                      = false,
  actived                        = [],
  badges,
  classNameNormal,
  classNamePushed,
  variant                        = "default",
  width,
  height,
  padding,
  margin,
  buttonForegroundColor,
  buttonBackgroundColor,
  buttonBackgroundHoverColor,
  buttonForegroundHoverColor,
  buttonBackgroundSelectedColor,   // ✅ Nouveau
  buttonForegroundSelectedColor,   // ✅ Nouveau
  buttonBackgroundDisabledColor,
  buttonForegroundDisabledColor,
  collapsibleBackgroundColor,
  collapsibleForegroundColor,
  titleBackgroundColor,
  titleForegroundColor,
  titleBackgroundHoverColor,
  titleForegroundHoverColor,
}: TriggerSetProps) => {

  const [currentChoices, setCurrentChoices] = useState<boolean[]>(
    actived.length ? actived : Array(choices.length).fill(false)
  );

  const handleChoiceClick = (index: number) => {
    let updatedChoices: boolean[];
    if (exclusive) {
      updatedChoices = Array(choices.length).fill(false);
      updatedChoices[index] = true;
    } else {
      updatedChoices = [...currentChoices];
      updatedChoices[index] = !updatedChoices[index];
    }
    setCurrentChoices(updatedChoices);
    onChoiceChange?.(index);
  };

  return (
    <div className={classNames(styles.triggerSet, styles[orientation])}>
      {choices.map((choice, index) => (
        <div key={index} className={styles.buttonSetItem}>
          {badges?.[index] && <span className={styles.badgeDot} role="status" aria-label="Nouveau" />}
          {subChoices && subChoices[index] ? (
            <CollapsibleTrigger
              title                         = {choice}
              actions                       = {[{
                name                          : subChoices[index].label,
                onClick                       : () => handleChoiceClick(index),
                iconName                      : subChoices[index].iconName,
                iconPosition                  : subChoices[index].iconPosition,
                variant,
                classNameNormal,
                classNamePushed,
                isActive                      : currentChoices[index],
                width,
                height,
                padding,
                margin,
                buttonForegroundColor,
                buttonBackgroundColor,
                buttonBackgroundHoverColor,
                buttonForegroundHoverColor,
                buttonBackgroundSelectedColor,  // ✅ Nouveau
                buttonForegroundSelectedColor,  // ✅ Nouveau
                buttonBackgroundDisabledColor,
                buttonForegroundDisabledColor,
              }]}
              width                         = {width}
              collapsibleBackgroundColor    = {collapsibleBackgroundColor}
              collapsibleForegroundColor    = {collapsibleForegroundColor}
              titleBackgroundColor          = {titleBackgroundColor}
              titleForegroundColor          = {titleForegroundColor}
              titleBackgroundHoverColor     = {titleBackgroundHoverColor}
              titleForegroundHoverColor     = {titleForegroundHoverColor}
            />
          ) : (
            <Trigger
              name                          = {choice}
              onClick                       = {() => handleChoiceClick(index)}
              iconName                      = {subChoices?.[index]?.iconName}
              iconPosition                  = {subChoices?.[index]?.iconPosition}
              classNameNormal               = {classNameNormal}
              classNamePushed               = {classNamePushed}
              isActive                      = {currentChoices[index]}
              variant                       = {variant}
              width                         = {width}
              height                        = {height}
              padding                       = {padding}
              margin                        = {margin}
              buttonForegroundColor         = {buttonForegroundColor}
              buttonBackgroundColor         = {buttonBackgroundColor}
              buttonBackgroundHoverColor    = {buttonBackgroundHoverColor}
              buttonForegroundHoverColor    = {buttonForegroundHoverColor}
              buttonBackgroundSelectedColor = {buttonBackgroundSelectedColor}  // ✅ Nouveau
              buttonForegroundSelectedColor = {buttonForegroundSelectedColor}  // ✅ Nouveau
              buttonBackgroundDisabledColor = {buttonBackgroundDisabledColor}
              buttonForegroundDisabledColor = {buttonForegroundDisabledColor}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default TriggerSet;